import { render, staticRenderFns } from "./IQCMenuPage.vue?vue&type=template&id=1cf30d3c&"
import script from "./IQCMenuPage.vue?vue&type=script&lang=js&"
export * from "./IQCMenuPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports